import VueCookie from "vue-cookie"
import {csrfCookieName} from "@/plugins/consts"
import {isNotEmpty} from "@/plugins/object-helpers"

/**
 * Перехватчик запросов, проходящих через экземпляр axios
 *
 * @param axiosInstance экземпляр axios
 * @param vueInstance экземпляр vue-приложения
 */
export function injectAxiosRequestInterceptor(axiosInstance, vueInstance) {
  axiosInstance.interceptors.request.use(async (config) => {
    // noinspection FallThroughInSwitchStatementJS
    switch (config.method) {
      case 'post':
      case 'put':
      case 'delete':
        config.headers.common['Csrf-Token'] = VueCookie.get(csrfCookieName)
      case 'get':
        config.headers.common['Authorization'] = `Token ${process.env.VUE_APP_WIDGET_TOKEN}`
        return config
      default:
        return config
    }
  }, (error) => {
    return Promise.reject(error)
  })
}

/**
 * Перехватчик ошибочных ответов, проходящих через экземпляр axios
 *
 * @param vueInstance экземпляр vue-приложения
 * @param error ошибочный ответ
 */
export function injectBasicAxiosErrorResponseInterceptor(vueInstance, error) {
  //Запрос был отменён
  if (error.code === 'ERR_CANCELED') {
    return Promise.reject(error)
  }

  //Пропал интернет
  if (error.code === 'ERR_NETWORK') {
    vueInstance.$eventBus.$emit('show-error', "Пропало соединение с интернетом")
    return Promise.reject(error)
  }

  //Таймаут соединения с бэкендом
  if (error.code === 'ECONNABORTED' && isNotEmpty(error.message) && error.message.startsWith('timeout of ') && error.message.endsWith(' exceeded')) {
    vueInstance.$eventBus.$emit('show-error', "Время ожидания ответа от сервера истекло.\nПопробуйте, пожалуйста, позже")
    return Promise.reject(error)
  }

  if (!error.response) {
    vueInstance.$eventBus.$emit('show-error', "Произошла ошибка, мы её уже исправляем.\nПопробуйте, пожалуйста, позже")
    return Promise.reject(error)
  }

  //Исключение для запросов /widget/send-sms и /widget/booking
  if (error.config.url.endsWith('/widget/send-sms') || error.config.url.endsWith('/widget/booking')) {
    return Promise.reject(error)
  }

  if (error.response.status >= 400 && error.response.status <= 499) {
    vueInstance.$eventBus.$emit('show-error', "Произошла ошибка, мы её уже исправляем.\nПопробуйте, пожалуйста, позже")
    return Promise.reject(error)
  }

  if (error.response.status >= 500 && error.response.status <= 599) {
    vueInstance.$eventBus.$emit('show-error', "На стороне сервера произошла ошибка, мы её уже исправляем.\nПопробуйте, пожалуйста, позже")
    return Promise.reject(error)
  }

  return Promise.reject(error)
}

/**
 * Перехватчик ответов, проходящих через экземпляр axios
 *
 * @param axiosInstance экземпляр axios
 * @param vueInstance экземпляр vue-приложения
 */
export function injectAxiosResponseInterceptor(axiosInstance, vueInstance) {
  axiosInstance.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      return injectBasicAxiosErrorResponseInterceptor(vueInstance, error)
    }
  )
}